import { render, staticRenderFns } from "./BasePrizepoolConfig.vue?vue&type=template&id=3302fcde&scoped=true&"
import script from "./BasePrizepoolConfig.vue?vue&type=script&lang=js&"
export * from "./BasePrizepoolConfig.vue?vue&type=script&lang=js&"
import style0 from "./BasePrizepoolConfig.vue?vue&type=style&index=0&id=3302fcde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3302fcde",
  null
  
)

export default component.exports